import React from 'react';
import FormInput from 'components/Input/FormInput';

interface IProps {
	changeTaxPercent: (value: Nullable<number>) => void;
}

export const TaxPercentField: React.FC<IProps> = React.memo(({ changeTaxPercent }) => (
	<FormInput
		testId="TaxPercentField"
		name="taxPercent"
		label="taxRateLabel"
		min={0}
		max={100}
		precision={1}
		onChangeNumber={changeTaxPercent}
		type="number"
	/>
));
